import { useReactiveVar } from '@apollo/client'
import React, { useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import OpenBillpayProvider from './context/provider'
import { RestAPICache } from './graphql/cache/localCache'
import { navigateRoute } from './utils/browserutils'
import routerpath, { FIRST_TIME_PAGE } from './constants/routerpath'
import { setSessionStorageValue } from './utils/sessionUtils'
import { BASE_PATH } from './config/connections'
import '../public/webview'
import ManualContainer from './pages/addManual/Manual'
import DashboardContainer from './pages/dashboard/DashboardPage'
import SearchPage from './pages/search'
import EditContainer from './pages/EditBill/index'
import FindBillsContainer from './container/payees/findbills/findbills'
import VerifyBills from './pages/verifybills/index'
import './index.scss'

import { infoLogger, initLogger } from './utils/loggerUtils'
import styles from './cssscoping.module.scss'

const AppRouter = () => {
  const { navigateRoutePath } = navigateRoute()
  // Initialize and Info the logger
  useEffect(() => {
    initLogger()
    infoLogger()
  }, [])

  const handleBackAction = (e) => {
    if (e?.detail?.page === FIRST_TIME_PAGE) {
      window.location.href = e.detail.navigateTo
      return
    }
    if (e?.detail?.navigateTo === routerpath.pages.openbillpay) {
      if (e?.detail?.data != null) {
        setSessionStorageValue(
          'billpayDeepLink',
          JSON.stringify(e?.detail?.data)
        )
      }

      window.location.href = routerpath.pages.openbillpay
      return
    }
    navigateRoutePath(`${e.detail.navigateTo}`)
  }

  useEffect(() => {
    document.addEventListener('OnBackAction', handleBackAction)

    return () => {
      document.removeEventListener('OnBackAction', handleBackAction)
    }
  }, [])
  const { isRestAPI = false } = useReactiveVar(RestAPICache) || {}
  return (
    <div className={styles['css-scoping-layer']}>
      <OpenBillpayProvider isRestAPI={isRestAPI}>
        <Routes>
          <Route path="/" element={<DashboardContainer />} />
          <Route
            path={`${BASE_PATH}${routerpath.pages.payeedashboard}`}
            element={<DashboardContainer />}
          />
          <Route path={BASE_PATH} element={<DashboardContainer />} />
          <Route
            path={`${BASE_PATH}${routerpath.pages.manual}`}
            element={<ManualContainer />}
          />
          <Route
            path={`${BASE_PATH}${routerpath.pages.search}`}
            element={<SearchPage />}
          />
          <Route
            path={`${BASE_PATH}${routerpath.pages.edit}`}
            element={<EditContainer />}
          />
          <Route
            path={`${BASE_PATH}${routerpath.pages.findbills}`}
            element={<FindBillsContainer />}
          />
          <Route
            path={`${BASE_PATH}${routerpath.pages.verifybills}`}
            element={<VerifyBills />}
          />
        </Routes>
      </OpenBillpayProvider>
    </div>
  )
}

export default React.memo(AppRouter)
